/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { DateInfoVO } from './DateInfoVO';
import { NameInfoVO } from './NameInfoVO';

export interface BasicInfoVO {
  birthDate?: DateInfoVO;
  /**
   * gender
   */
  gender?: string;
  name?: NameInfoVO;
  /**
   * firstname in a PNR
   */
  pnrFirstName?: string;
  /**
   * lastname in a PNR
   */
  pnrLastName?: string;
}
